import { pick } from 'lodash-es'

const transformToUpdateMenuScrapingTemplateInput = ({ id, ...data }) => ({
  id,
  data: pick(data, ['name', 'status', 'scrapingInstructions']),
})

export default transformToUpdateMenuScrapingTemplateInput
